import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const white = constants.colors.ui.white[100];

export const contentRootCss: CSSObject = {
  backgroundColor: white,
  "& article": {
    marginTop: 0,
    paddingTop: 0,
  },
};

export const mainSectionWrapperCss = (
  isVideoOnly: boolean = false,
): CSSObject => ({
  ...(isVideoOnly ? { maxWidth: "800px", margin: "0 auto" } : {}),
});
